// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__jV5Vq","alert":"SettungsInbox_alert__1906L"};